// Header.js
import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import mark1 from "../assets/img/users.png";
import Hero from "../assets/img/Agrifresh_Logo.png";
import "../assets/css/Header.css";
import { AuthContext } from "../auth/AuthContext";
import Swal from "sweetalert2";
import axios from "axios";

function Header() {
	const { isAuthenticated, logout, profile, token } = useContext(AuthContext);
	const [profilePic, setProfilePic] = useState(mark1);
	const [open, setOpen] = useState(false);
	const dropdownRef = useRef(null);
	const baseURL = process.env.REACT_APP_API_URL;
	const navigate = useNavigate();

	useEffect(() => {
		if (isAuthenticated && profile?.profile_pic) {
			setProfilePic(`${baseURL}/uploads/${profile.profile_pic}`);
		} else {
			setProfilePic(mark1);
		}
	}, [isAuthenticated, profile, baseURL]);

	// close dropdown on outside click
	useEffect(() => {
		const handleClickOutside = (e) => {
			if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
				setOpen(false);
			}
		};
		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, []);


	const handleProfile = () => {
		setOpen(false);
		navigate("/profile"); // ✅ apne profile page ka route yaha set karo
	};

	const handleLogout = async () => {
		const ok = await Swal.fire({
			title: "Logout?",
			text: "You will be logged out now.",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Yes, Logout",
			cancelButtonText: "Cancel",
			confirmButtonColor: "#d33",
		});
		if (ok.isConfirmed) {
			setOpen(false);
			logout();
		}
	};
	const handleChangePassword = async () => {
		const { value: formValues } = await Swal.fire({
			title: "Change Password",
			html:
				`<input id="old" type="password" class="swal2-input" placeholder="Old Password">` +
				`<input id="new" type="password" class="swal2-input" placeholder="New Password">` +
				`<input id="confirm" type="password" class="swal2-input" placeholder="Confirm Password">`,
			focusConfirm: false,
			preConfirm: () => {
				const oldP = document.getElementById("old").value;
				const newP = document.getElementById("new").value;
				const conP = document.getElementById("confirm").value;

				if (!oldP || !newP || !conP) {
					Swal.showValidationMessage("All fields required");
					return false;
				}
				if (newP !== conP) {
					Swal.showValidationMessage("Passwords do not match");
					return false;
				}
				return { oldP, newP };
			}
		});

		if (!formValues) return;

		try {
			await axios.post(
				`${baseURL}/dashboard/change-password`,
				formValues,
				{ headers: { "x-access-token": token } }
			);
			Swal.fire("Success", "Password changed successfully", "success");
		} catch (e) {
			Swal.fire("Error", e.response?.data?.message || "Failed", "error");
		}
	};
	const displayName = profile?.fullname || profile?.username || "Admin";

	return (
		<header className="af-header">
			{/* Left: Logo */}
			<Link to="/" className="af-logo">
				<img src={Hero} alt="Agrifresh Logo" />
			</Link>
			{/* Right: User Area */}
			<div className="af-right">
				{!isAuthenticated ? (
					<Link to="/login" className="af-login-btn">
						<i className="fa fa-sign-in"></i> Login
					</Link>
				) : (
					<div className="af-user" ref={dropdownRef}>
						<button
							type="button"
							className="af-user-btn"
							onClick={() => setOpen((p) => !p)}
						>
							<img className="af-avatar" src={profilePic} alt="User" />
							<div className="af-user-text">
								<div className="af-welcome">Welcome,</div>
								<div className="af-name">{displayName}</div>
							</div>
							<i className={`fa fa-chevron-down af-caret ${open ? "open" : ""}`}></i>
						</button>

						{open && (
							<div className="af-dropdown">
								<button className="af-dd-item" onClick={handleProfile}>
									<i className="fa fa-user"></i> My Profile
								</button>
								<div className="af-dd-divider" />
								<button className="af-dd-item" onClick={handleChangePassword}>
									<i className="fa fa-lock"></i> Change Password
								</button>
								<div className="af-dd-divider" />
								<button className="af-dd-item danger" onClick={handleLogout}>
									<i className="fa fa-sign-out"></i> Logout
								</button>
							</div>
						)}
					</div>
				)}
			</div>
		</header>
	);
}

export default Header;
